
import ActivityPage from '~/pages/_lang/activity/_url'
export default ActivityPage
